import type { ApiGenerateParentReportRequest, ParentReportRequest } from '../types';

export const toApiGenerateParentReportRequest = (request: ParentReportRequest): ApiGenerateParentReportRequest => ({
  locales: [...request.languages],
  noteIds: [...request.noteIds],
});
